import { render, staticRenderFns } from "./ShibouDoukishoEdit.vue?vue&type=template&id=2c23fd6b&scoped=true"
import script from "./ShibouDoukishoEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShibouDoukishoEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShibouDoukishoEdit.vue?vue&type=style&index=0&id=2c23fd6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c23fd6b",
  null
  
)

export default component.exports